export function parseBet(bet: string): number {
  const numBet = Number(bet);

  return Number.isNaN(numBet) ? 0 : numBet;
}
